import React, { ReactNode } from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './StatusIndicator.st.css';
import Tooltip from '../Tooltip';
import {
  FormFieldSuccessFilled,
  FormFieldWarningFilled,
  FormFieldErrorFilled,
} from '@wix/wix-ui-icons-common/system';
import Loader from '../Loader';
import {
  dataHooks,
  STATUS,
  TOOLTIP_PLACEMENT,
} from './StatusIndicator.constants';
import {
  StatusIndicatorProps,
  StatusIndicatorState,
} from './StatusIndicator.types';

const statusToIconMap: Record<StatusIndicatorState, ReactNode> = {
  success: <FormFieldSuccessFilled />,
  warning: <FormFieldWarningFilled />,
  loading: <Loader size="tiny" />,
  error: <FormFieldErrorFilled />,
};

const StatusIndicator = ({
  dataHook,
  status = STATUS.ERROR,
  message,
  tooltipPlacement = TOOLTIP_PLACEMENT.TOP,
  className,
  tooltipProps,
}: StatusIndicatorProps) => {
  return (
    <div
      className={st(classes.root, { status }, className)}
      data-hook={dataHook}
      data-status={status}
    >
      {message ? (
        <Tooltip
          dataHook={dataHooks.tooltip}
          appendTo="window"
          placement={tooltipPlacement}
          exitDelay={100}
          content={message}
          maxWidth={250}
          {...tooltipProps}
        >
          {statusToIconMap[status]}
        </Tooltip>
      ) : (
        statusToIconMap[status]
      )}
    </div>
  );
};

StatusIndicator.displayName = 'StatusIndicator';

StatusIndicator.propTypes = {
  dataHook: PropTypes.any,
  className: PropTypes.any,
  status: PropTypes.any,
  message: PropTypes.any,
  tooltipPlacement: PropTypes.any,
  tooltipProps: PropTypes.any,
};

export default StatusIndicator;
